import React, { useState, useRef, useEffect } from 'react';
import { Moon, Sun } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';
import { Button } from './ui/button';

const BedtimeToggle = () => {
  const { isBedtimeMode, bedtimeMode, setBedtimeMode } = useTheme();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    const onDocClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', onDocClick);
    return () => document.removeEventListener('mousedown', onDocClick);
  }, [open]);

  const ModeButton = ({ value, label, hint }) => (
    <button
      data-testid={`bedtime-mode-${value}`}
      onClick={() => setBedtimeMode(value)}
      className={`w-full text-left px-3 py-2 rounded-xl text-sm font-medium transition-colors flex items-center justify-between ${
        bedtimeMode === value
          ? 'bg-gold/15 border border-gold/40 text-foreground'
          : 'bg-muted/30 hover:bg-muted/50 text-muted-foreground border border-transparent'
      }`}
    >
      <span>{label}</span>
      <span className="text-[10px] font-accent text-muted-foreground">{hint}</span>
    </button>
  );

  return (
    <div className="relative" ref={ref}>
      <Button
        data-testid="bedtime-toggle"
        variant="ghost"
        size="icon"
        onClick={() => setOpen((o) => !o)}
        className="rounded-full"
        aria-label="Bedtime-modus"
      >
        {isBedtimeMode ? (
          <Moon className="w-5 h-5 text-amber-300" />
        ) : (
          <Sun className="w-5 h-5 text-amber-500" />
        )}
      </Button>

      {open && (
        <div
          data-testid="bedtime-popover"
          className="absolute right-0 mt-2 w-72 bg-card border border-border rounded-2xl shadow-xl p-4 z-50"
        >
          <div className="flex items-center gap-2 mb-2">
            <Moon className="w-4 h-4 text-amber-400" />
            <span className="font-display text-lg text-foreground">Bedtime Mode</span>
          </div>
          <p className="text-xs text-muted-foreground font-accent mb-3 leading-relaxed">
            Warmere amber-kleuren en zachtere knoppen. Beter voor jonge oogjes vlak voor het slapengaan.
          </p>
          <div className="space-y-1.5">
            <ModeButton value="off"  label="Uit"   hint="Altijd helder" />
            <ModeButton value="auto" label="Auto"  hint="19:00 — 06:00" />
            <ModeButton value="on"   label="Aan"   hint="Altijd warm" />
          </div>
          <p className="text-[10px] text-muted-foreground font-accent mt-3 leading-relaxed">
            Tip: tijdens een verhaal kun je via de 🔊 knop bovenin ook regen of kachelvuur op de achtergrond zetten.
          </p>
        </div>
      )}
    </div>
  );
};

export default BedtimeToggle;
